"use client";
import React from "react";
// @ts-ignore
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";

import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useModeAnimation } from 'react-theme-switch-animation'

type Props = {};

function ThemeSelector({}: Props) {
  const { ref, toggleSwitchTheme, isDarkMode } = useModeAnimation();
	const { setTheme } = useTheme();

	const toggleTheme = React.useCallback(async () => {
		await toggleSwitchTheme();
		setTheme(isDarkMode ? 'light' : 'dark');
	}, [isDarkMode, setTheme, toggleSwitchTheme]);

	return (
		<Button className="flex items-start overflow-hidden" ref={ref} variant="outline" size="icon" onClick={toggleTheme}>
			<div className="w-[38px] h-[76px] relative transition duration-500 rotate:0 dark:-rotate-180">
				<div className="absolute top-0 size-[38px] flex-center">
					<SunIcon />
				</div>
				<div className="absolute bottom-0 size-[38px] flex-center">
					<MoonIcon className="rotate-180" />
				</div>
			</div>
			<span className="sr-only">Trocar Tema</span>
		</Button>
	);
}

export default ThemeSelector;
